import React from "react";

type Props = {
  theme: "blue" | "white";
};

function StarsIcon({ theme }: Props) {
  return (
    <>
      {theme == "blue" && (
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.734 9.56635L8.02228 5.7015H8.81285L10.1011 9.56635L13.966 10.8546V11.6452L10.1011 12.9335L8.81285 16.7984H8.02228L6.734 12.9335L2.86914 11.6452V10.8546L6.734 9.56635Z"
            fill="#1E40AF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.0257 4.35802L14.689 2.36816H15.4795L16.1428 4.35802L18.1327 5.02131V5.81188L16.1428 6.47516L15.4795 8.46502H14.689L14.0257 6.47516L12.0358 5.81188V5.02131L14.0257 4.35802Z"
            fill="#1E40AF"
          />
        </svg>
      )}

      {theme == "white" && (
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.734 9.56635L8.02228 5.7015H8.81285L10.1011 9.56635L13.966 10.8546V11.6452L10.1011 12.9335L8.81285 16.7984H8.02228L6.734 12.9335L2.86914 11.6452V10.8546L6.734 9.56635Z"
            fill="#9CA3AF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.0257 4.35802L14.689 2.36816H15.4795L16.1428 4.35802L18.1327 5.02131V5.81188L16.1428 6.47516L15.4795 8.46502H14.689L14.0257 6.47516L12.0358 5.81188V5.02131L14.0257 4.35802Z"
            fill="#9CA3AF"
          />
        </svg>
      )}
    </>
  );
}

export default StarsIcon;
